import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-api-reference',
  templateUrl: './api-reference.component.html',
  styleUrls: ['./api-reference.component.css']
})
export class ApiReferenceComponent implements OnInit {
  requiresOrgAdminString = 'Requires the request to either be from the user or the user\'s organization admin.';
  endpointHeaders: HTMLCollectionOf<Element>;

  constructor() {

  }

  ngOnInit(): void {
    this.endpointHeaders = document.getElementsByClassName('endpoint-header');

  }

  scrollToElement(header: any) {
    console.log(header);
    header.scrollIntoView();
  }

  navigateToApiKeys() {
    // navigate to /api-keys with angular router

  }
}
